export default "__VITE_ASSET__BfqwNTq7__"